import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

import { QuoteDetailsComponent } from './pages/kenya/quote-details/quote-details.component';
import { KycComponent } from './pages/kenya/kyc/kyc.component';

import { ClaimDetailsComponent } from './pages/kenya/claims/claim-details/claim-details.component';
import { ClaimComponent } from './pages/kenya/claims/claim/claim.component';
import { Page2Component } from './pages/kenya/claims/claim-details/page2/page2.component';
import { Page3Component } from './pages/kenya/claims/claim-details/page3/page3.component';
import { Page4Component } from './pages/kenya/claims/claim-details/page4/page4.component';

import { QuoteDetailsUGComponent } from './pages/uganda/quote-details/quote-details.component';
import { ClaimDetailsComponentUG } from './pages/uganda/claim-details/claim-details.component';

import { BenefitsComponent } from './pages/tanzania/benefits/benefits.component';
import { DetailsTZComponent } from './pages/tanzania/detailsTZ/detailsTZ.component';
import { ClaimComponentTZ } from './pages/tanzania/claim/claim.component';
import { TheftDetailsComponent } from './pages/kenya/claims/theft-details/theft-details.component';
import { PesapalWebhookComponent } from './pages/kenya/pesapal-webhook/pesapal-webhook.component';
import { PesapalPayComponent } from './pages/kenya/pesapal-pay/pesapal-pay.component';
import { FnolComponent } from './pages/kenya/claims/fnol/fnol.component';
import { DetailsComponent } from './pages/kenya/claims/details/details.component';
import { PaTierBreakdownComponent } from './pages/kenya/pa-tier-breakdown/pa-tier-breakdown.component';
import { StudentPaKycComponent } from './pages/kenya/student-pa-kyc/student-pa-kyc.component';
import { SspLoginComponent } from './pages/uganda/ssp-login/ssp-login.component';
import { BuyComponent } from './pages/tanzania/third-party/buy/buy.component';
import { DpQuoteComponent } from './pages/kenya/domestic-package/quote/quote.component';
import { DpPersonalDetailsComponent } from './pages/kenya/domestic-package/personal-details/personal-details.component';
import { DpBuildingDetailsComponent } from './pages/kenya/domestic-package/building-details/building-details.component';
import { DpImeiDetailsComponent } from './pages/kenya/domestic-package/imei-details/imei-details.component';
import { DpClaimComponent } from './pages/kenya/domestic-package/claim/claim.component';

const routes: Routes = [
  { path: '', component: AppComponent, pathMatch: 'full'},
  // KE
  { path: 'quote-details', component: QuoteDetailsComponent },
  { path: 'kyc', component: KycComponent },
  { path: 'payment', component: PesapalWebhookComponent },
  { path: 'payment-status', component: PesapalPayComponent },
  { path: 'pa-tier-breakdown', component: PaTierBreakdownComponent },
  { path: 'student-pa-kyc', component: StudentPaKycComponent },
  // Claims Ke
  { path: 'claim-details', component: ClaimDetailsComponent },
  { path: 'theft-details', component: TheftDetailsComponent },
  { path: 'claim', component: ClaimComponent },
  { path: 'claim-details/page2', component: Page2Component },
  { path: 'claim-details/page3', component: Page3Component },
  { path: 'claim-details/page4', component: Page4Component },
  // VERSION 2 KE
  { path: 'claim-form/fnol', component: FnolComponent },
  { path: 'claim-form/details', component: DetailsComponent },

  // Domestic Package KE
  { path: 'dp-chat/quote', component: DpQuoteComponent },
  { path: 'dp-chat/personal-details', component: DpPersonalDetailsComponent },
  { path: 'dp-chat/building-details', component: DpBuildingDetailsComponent },
  { path: 'dp-chat/imei-details', component: DpImeiDetailsComponent },
  { path: 'dp-chat/claim', component: DpClaimComponent },

  // UG
  { path: 'ug/quote-details', component: QuoteDetailsUGComponent },
  { path: 'ug/claim-details', component: ClaimDetailsComponentUG },
  { path: 'ug/ssp-login', component: SspLoginComponent },

  // TZ
  {path: 'tz/benefits', component: BenefitsComponent},
  {path: 'tz/details', component: DetailsTZComponent},
  {path: 'tz/claim', component: ClaimComponentTZ},
  {path: 'tz/third-party/kyc', component: BuyComponent}
];

// {{base-url}}/ug/quote-details

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
